export default __webpack_public_path__ + "static/legal-massachusetts-delta-8-83cfe9a8151e56c33ef2cb6bf97edda2.png";